import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { unwrapData } from '@ftr/foundation'
import { firstValueFrom } from 'rxjs'
import { CoreConfigurationService } from '../services/core-configuration.service'

/**
 * This directive shows or hides an element based on whether departments are enabled
 */
@Directive({
  selector: '[ifDepartmentsEnabled]',
  standalone: true,
})
export class IfDepartmentsEnabledDirective implements OnInit {
  private courtSystemId: Uuid

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private configurationService: CoreConfigurationService,
  ) {}

  async ngOnInit(): Promise<void> {
    const config = await firstValueFrom(
      this.configurationService.getByCourtSystem(this.courtSystemId).pipe(unwrapData()),
    )

    if (config) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()
    }
  }

  @Input()
  set ifDepartmentsEnabled(value: Uuid) {
    this.courtSystemId = value
  }
}
